import { PhotosetFinal } from '@/features/photoset/components/photoset-final'
import { Trans, useTranslation } from '@/translations/i18n'

export const PhotosetRetouchingQaCompletedStep = () => {
	const { t } = useTranslation()

	return (
		<PhotosetFinal
			status='success'
			subtitle={t('photoset:retouching_qa_completed.subtitle')}
			title={
				<Trans
					components={{ br: <br /> }}
					i18nKey={'photoset:retouching_qa_completed.title'}
				/>
			}
		/>
	)
}
